import React from 'react';
import { weight } from '../data/masterclass';
export function SuccessAddsWeight() {
  return <section aria-labelledby="weight-heading" className="border-t border-ink-line bg-ink-soft" data-id="element-145" data-mp="21spepn4556sw">
      <div className="mx-auto w-full max-w-5xl px-6 py-20 lg:py-28" data-id="element-146" data-mp="1nzq2btznnspk">
        <h2 id="weight-heading" className="font-display text-5xl font-bold uppercase text-white sm:text-6xl" data-id="element-147" data-mp="1szm7hwk39q6p">
          Success adds <span className="text-gold" data-id="element-148" data-mp="1e11ybz4i9e4v">weight.</span>
        </h2>

        <ul className="mt-12 divide-y divide-ink-line border-y border-ink-line" data-id="element-149" data-mp="1j1ybz4ensenh">
          {weight.lines.map(line => <li key={line} className="py-5 text-xl leading-snug text-white/75 sm:text-2xl" data-id="element-150" data-mp="1538c5h0gg0vf">
              {line}
            </li>)}
        </ul>

        <p className="mx-auto mt-16 max-w-3xl text-center font-display text-3xl font-bold uppercase leading-tight text-gold sm:text-4xl" data-id="element-151" data-mp="2zh9ck6bnkvxm">
          Success isn’t the enemy. Unprepared infrastructure is.
        </p>

        <p className="mx-auto mt-6 max-w-3xl text-center text-lg leading-relaxed text-white/65" data-id="element-152" data-mp="3bz7qpf4aeovs">
          {weight.close}
        </p>
      </div>
    </section>;
}